// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3b1acd4f","arrowBox":"_7d8582d0","leftArrowBox":"_c368f2b _7d8582d0","rightArrowBox":"_2c9cb910 _7d8582d0","arrow":"_6066b585","inactive":"_a2c6df17"};